
import { TypedTable } from "@/components/ui/table/TypedTable";
import { useEffect, useMemo, } from "react";
import { createColumnHelper, tableFeatures, type RowSelectionState } from "@tanstack/react-table";
import { useMaquinasUsuario, type Maquina } from "./ModalMaquinasUsuario";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { getSelectionCell } from "@/components/ui/table/datatable";

interface TablaMaquinasUsuarioProps {
	readonly idRepresentante: string,
	readonly selectedMaquinas: RowSelectionState;
	readonly setSelectedMaquinas: Setter<RowSelectionState>;
}
export function TablaMaquinasUsuario(props: TablaMaquinasUsuarioProps) {
	const { selectedMaquinas, setSelectedMaquinas } = props;
	const { data, error, isPending } = useMaquinasUsuario(props.idRepresentante);

	useEffect(() => {
		if (!data) return;
		const initialSelection: RowSelectionState = {};

		data.forEach(maquina => {
			if (maquina.check == true) initialSelection[maquina.xoperacion_id] = true;
		});

		setSelectedMaquinas(initialSelection);
	}, [data, setSelectedMaquinas]);

	const { columns, features } = useMemo(() => Columns(), []);


	return (
		<TypedTable
			className="display dataTable"
			data={data ?? []}
			columns={columns}
			features={features}

			selection={selectedMaquinas}
			getRowId={row => row.xoperacion_id}
			setSelection={setSelectedMaquinas}

			noResultsMessage="No hay entradas"
			errorMessage="Error al cargar las máquinas"
			isLoading={isPending}
			isError={error != null}
		/>
	);
}





function Columns() {
	const columnHelper = createColumnHelper<typeof features, Maquina>();
	const features = tableFeatures(CommonFeatures);


	const columns = columnHelper.columns([
		columnHelper.accessor("xoperacion_id", { header: "Id", }),
		columnHelper.accessor("xdescripcion", { header: "Descripción", }),
		columnHelper.accessor("operariosCount", { header: "Nº Operarios", }),
		columnHelper.display({
			id: "checkbox",
			header: "Asignado?",
			cell: (info) => getSelectionCell(info.row),
		}),
	]);
	return { columns, features };
}